// extracted by mini-css-extract-plugin
export var logo = "_lo-2";
export var logoWrapper = "_lo-1";
export var strip = "_lo-0";